module.exports = __webpack_public_path__ + "static/media/Gor 2018.10.12.283a596c.jpg";